import classnames from 'classnames';
import { MonthStatus } from './status/month';
import { Image } from '@/components/Image';
import s from './index.module.scss';
import { useTranslation } from 'react-i18next';

export const RoundDetailRepaymentProgress = ({ graph, selected }) => {
  const { t } = useTranslation('round_history');

  if (!graph) {
    return null;
  }

  const { payments, postponed_brands, extended_brands, is_new_terms } = graph;

  const stats = payments.reduce(
    (acc, item) => {
      if (
        item.status === 'completed' ||
        item.status === 'extended' ||
        item.status === 'postponed'
      ) {
        acc.paid += 1;
      }
      return acc;
    },
    { paid: 0, total: payments.length },
  );

  const hasPaidAll = stats.total === stats.paid;

  const isOldRounds = selected.id < 94;

  return (
    <div className={s.wrapper}>
      <div className="single_s">{t('round_repayments_progress')}</div>

      <div className={classnames(s.info, 'f-14')}>
        {hasPaidAll ? (
          <div className={s.info__column}>
            <div className={s.info__item}>{t('all_repayments_made')}</div>
          </div>
        ) : (
          <>
            {is_new_terms ? (
              <>
                <div className={s.info__column}>
                  {!!postponed_brands?.length && (
                    <>
                      <div className={s.info__item}>
                        {t('postponed_loan_repayment')}
                      </div>
                      <div className={s.info__brands}>
                        {postponed_brands?.map(brand => (
                          <BrandIcon brand={brand} key={brand.id} />
                        ))}
                      </div>
                    </>
                  )}
                  {!!extended_brands?.length && (
                    <>
                      <div className={s.info__item}>
                        {t('extended_loan_repayment')}
                      </div>
                      <div className={s.info__brands}>
                        {extended_brands?.map(brand => (
                          <BrandIcon brand={brand} key={brand.id} />
                        ))}
                      </div>
                    </>
                  )}
                  {isOldRounds && (
                    <div className={s.info__item}>{t('flat_fee_paid')}</div>
                  )}
                  <div className={s.info__item}>
                    {t('monthly_payments_completed', {
                      paid: stats.paid,
                      total: stats.total,
                    })}
                  </div>
                </div>
                <div className={s.info__column}>
                  <div className={s.info__item}>
                    {t('more_repayments_expected', {
                      count: stats.total - stats.paid,
                    })}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className={s.info__column}>
                  {!!postponed_brands?.length && (
                    <>
                      <div className={s.info__item}>
                        {t('postponed_loan_repayment')}
                      </div>
                      <div className={s.info__brands}>
                        {postponed_brands?.map(brand => (
                          <BrandIcon brand={brand} key={brand.id} />
                        ))}
                      </div>
                    </>
                  )}

                  {!!extended_brands?.length && (
                    <>
                      <div className={s.info__item}>
                        {t('extended_loan_repayment')}
                      </div>
                      <div className={s.info__brands}>
                        {extended_brands?.map(brand => (
                          <BrandIcon brand={brand} key={brand.id} />
                        ))}
                      </div>
                    </>
                  )}

                  <div className={s.info__item}>
                    {t('monthly_payments_completed', {
                      paid: stats.paid,
                      total: stats.total,
                    })}
                  </div>
                </div>
                <div className={s.info__column}>
                  <div className={s.info__item}>
                    {t('more_repayments_expected', {
                      count: stats.total - stats.paid,
                    })}
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      {!!payments?.length && (
        <div className={s.graph}>
          {payments.map((month, index) => (
            <MonthStatus
              key={month.deadline}
              month={month}
              index={index + 1}
              className={s.card}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const BrandIcon = ({ brand }) => (
  <div className={s.brand}>
    <Image
      image={brand.promo_image}
      preset="brandRoundIcon"
      width={40}
      height={40}
      alt={brand.name}
    />
  </div>
);
